import React, { useState } from 'react';
import { Modal, Form, Button, Badge } from 'react-bootstrap';
import { FaCheck, FaTimes } from 'react-icons/fa';

const LIMITE_OBS = 99;

const formatarMoeda = (valor) =>
  Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function PainelConferencia({ linha, onLancar, onCancelar }) {
  const saldoNegativo = Number(linha.saldo) < 0;

  const [notaFiscal, setNotaFiscal] = useState('');
  const [observacoes, setObservacoes] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleObservacoes = (e) => {
    const val = e.target.value;
    setObservacoes(val.length > LIMITE_OBS ? val.substring(0, LIMITE_OBS) : val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!observacoes.trim()) return;
    if (!saldoNegativo && !notaFiscal.trim()) return;

    setIsLoading(true);
    try {
      await onLancar({
        conta: linha.codigo_conta,
        ge: linha.ge,
        ativo: linha.codigo_ativo,
        saldo: Number(linha.saldo),
        nota_fiscal: saldoNegativo ? null : notaFiscal,
        observacoes,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show centered onHide={onCancelar} backdrop="static">
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title className='text-white'>Lancar Saldo Conferido</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-wrap mb-4" style={{ fontSize: '1.1rem', gap: '0.5rem 1rem' }}>
          <div className="d-flex align-items-center">
            <strong className="mr-2">GE:</strong>
            <Badge variant="info" style={{ fontSize: '1rem' }}>{linha.ge}</Badge>
          </div>
          <div className="d-flex align-items-center">
            <strong className="mr-2">Moeda:</strong>
            <Badge variant="info" style={{ fontSize: '1rem' }}>{linha.nome}</Badge>
          </div>
          <div className="d-flex align-items-center">
            <strong className="mr-2">Saldo:</strong>
            <Badge variant={saldoNegativo ? 'danger' : 'success'} style={{ fontSize: '1rem' }}>
              {formatarMoeda(linha.saldo)}
            </Badge>
          </div>
        </div>

        <Form onSubmit={handleSubmit} id="form-conferencia">
          {!saldoNegativo && (
            <Form.Group className="mb-3">
              <Form.Label>Nota Fiscal</Form.Label>
              <Form.Control
                type="text"
                maxLength={200}
                value={notaFiscal}
                onChange={e => setNotaFiscal(e.target.value)}
                required
              />
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Observacoes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={observacoes}
              onChange={handleObservacoes}
              required
            />
            <small className="text-muted">
              {LIMITE_OBS - observacoes.length} caracteres restantes
            </small>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex flex-column flex-sm-row">
        <Button variant="danger" onClick={onCancelar} disabled={isLoading} className="flex-fill mb-2 mb-sm-0 mr-sm-2">
          <FaTimes /> Cancelar
        </Button>
        <Button type="submit" form="form-conferencia" variant="success" disabled={isLoading} className="flex-fill">
          <FaCheck /> Lancar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
